var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoRgd(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 144,
    height: 100,
    viewBox: "0 0 144 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_588_179)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M143.325 100H0.00817871V-1.79754e-06H143.325V100Z",
    fill: "#E43024"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.0348 29.4207V31.25H105.815C106.756 31.25 108.101 31.25 109.042 32.3171C109.983 33.3841 109.983 34.9085 109.983 35.9756V51.6006C109.983 52.6677 109.983 54.1921 109.042 55.2591C108.101 56.3262 106.756 56.3262 105.815 56.3262H99.1603C98.0176 56.3262 96.5387 56.3262 95.9337 54.878C95.3287 53.4299 96.1354 52.1341 96.8748 51.0671L105.815 37.5H92.0348L86.5227 45.8079C85.5816 47.1799 84.7749 48.3994 84.7749 50C84.7749 51.5244 85.5143 52.6677 86.5227 54.1921L87.9343 56.25C89.2787 58.3079 90.6904 60.4421 92.5054 61.4329C94.3204 62.5 96.5387 62.5 99.4964 62.5H105.479C108.907 62.5 114.084 62.5 117.512 58.6128C120.94 54.7256 120.94 49.0091 120.94 46.875V40.625C120.94 38.5671 120.94 32.8506 117.512 28.8872C114.084 25 108.907 25 105.479 25H95.9337C94.9926 25 93.8498 25 92.9759 26.0671C92.0348 27.1341 92.0348 28.4299 92.0348 29.4207Z",
    fill: "#FEFEFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.4983 37.5H89.2787L72.7422 62.5H58.9618L75.4983 37.5Z",
    fill: "#FEFEFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.721 41.9207C21.721 40.8537 21.721 39.5579 22.6621 38.5671C23.6032 37.5 24.746 37.5 25.6199 37.5H48.6769C51.6346 37.5 53.8529 37.5 55.6679 38.5671C57.4829 39.6341 58.8946 41.6921 60.239 43.75L61.5834 45.8079C62.5917 47.2561 63.3312 48.3994 63.3312 50C63.3312 51.6006 62.5245 52.7439 61.5834 54.1921L56.0713 62.5H42.2908L51.2313 48.9329C51.9035 47.8659 52.7102 46.5701 52.1724 45.122C51.5674 43.6738 50.0885 43.6738 48.9458 43.6738H38.1903V74.9238H27.166V43.6738H21.6538V41.8445L21.721 41.9207Z",
    fill: "#FEFEFE"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_588_179"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 143.333,
    height: 100,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoRgd);
export default __webpack_public_path__ + "static/media/logo_rgd.a52e3f527531585a37db81c617fd18e3.svg";
export { ForwardRef as ReactComponent };